export default __webpack_public_path__ + "static/media/home-banner2.35b77e2a.png";